import React from 'react';

const AnnouncementsPage = () => {
    return (
        <div>
            
        </div>
    );
}

export default AnnouncementsPage;
